import { useEffect, useState } from "react";
import { Box, Flex, Text, IconButton, useDisclosure, Grid, GridItem, Center, Spinner } from "@chakra-ui/react";
import MyDiv from "./certificate.style";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import { AwardListItem } from "./model";
import CustomButton from "../../../components/Inputs/Button/customButton";
import { AlertCard, CustomTable } from "../../../components";
import { Column } from "../../../components/CustomTable/customTable";
import { useFetch } from "../../../hooks/useFetch";
import { CustomToast } from "../../../components";
import { showDate } from "../../../utilities/helper";
import { CreateNewAward } from "../components";

const AdminCertificate = () => {
  const [awards, setAwards] = useState<AwardListItem[]>([]);
  const [deleteAward, setDeleteAward] = useState<AwardListItem | null>(null);
  const [editAward, setEditAward] = useState<AwardListItem | null>(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  const fetchAwards = async () => {
    try {
      const res = await fetchApi("Hrlense_Awards/allawards", "GET");
      if (res) {
        setAwards(res);
      }
    } catch (error) {
      console.error("Error fetching Award:", error);
    }
  };

  useEffect(() => {
    fetchAwards();
  }, []);

  const handleEdit = (award: AwardListItem) => {
    setEditAward(award);
    onOpen();
  };

  const handleUpdate = async (data: any) => {
    const formData = new FormData();

    formData.append("title", data.title);
    formData.append("description", data.description);
    formData.append("category", data.category);
    formData.append("type", data.type);
    formData.append("validity", data.validity);
    formData.append("Recipients", JSON.stringify(data.recipients));

    if (data.template) {
      formData.append("File", data.template);
    }

    const res = await fetchApi(
      `Hrlense_Awards/updateaward/${data.awardId}`,
      "PUT",
      formData,
      null,
      "Award Updated Successfully",
      true,
    );

    if (res) {
      fetchAwards();
      onClose();
    }
  };

  const confirmDelete = async () => {
    if (!deleteAward) return;
    const res = await fetchApi(
      `Hrlense_Awards/deleteaward/${deleteAward.awardId}`,
      "DELETE",
      null,
      null,
      "Award Deleted Successfully"
    );

    if (res) {
      fetchAwards();
      setDeleteAward(null);
    }
  };

  return (
    <MyDiv>
      <Flex className="page_heading flex_header">
        <Text className="font-poppins text_semibold text_3xl"> Award & Certificate</Text>
        <Flex>
          <CustomButton
            title="Create New Award & Certificate"
            className="btn font-poppins text_md text_medium"
            onClick={() => {
              setEditAward(null);
              onOpen();
            }}
          />

        </Flex>
      </Flex>

      <Grid className='grid_container' mt={1}>
        <GridItem colSpan={12}>
          <Box position="relative" minH="300px">
            {loading ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
              </Center>
            ) : (
              <>
                <CustomTable value={awards} emptyMessage="No awards found">
                  <Column header="S.No" body={(_, i) => i + 1} />
                  <Column
                    header="Title"
                    body={(rowData: AwardListItem) => rowData.title}
                  />
                  <Column
                    header="Type"
                    body={(rowData: AwardListItem) => rowData.type}
                  />
                  <Column
                    header="Validity"
                    body={(rowData: AwardListItem) => rowData.validityType}
                  />
                  <Column
                    header="Category"
                    body={(rowData: AwardListItem) => rowData.category}
                  />
                  <Column
                    header="Recipient"
                    body={(rowData: AwardListItem) => rowData.employeeName}
                  />

                  <Column
                    header="Issued Date"
                    body={(rowData: AwardListItem) => showDate(rowData.issuedDate)}
                  />
                  <Column
                    header="Created Date"
                    body={(rowData: AwardListItem) => showDate(rowData.createdAt)}
                  />

                  <Column
                    header="Action"
                    body={(rowData: AwardListItem) => (
                      <Flex gap={2}>
                        <IconButton
                          aria-label="Edit"
                          icon={<EditIcon />}
                          size="sm"
                          onClick={() => handleEdit(rowData)}
                        />

                        <IconButton
                          aria-label="Delete"
                          icon={<DeleteIcon />}
                          size="sm"
                          colorScheme="red"
                          onClick={() => {
                            setDeleteAward(rowData);
                          }}

                        />
                      </Flex>
                    )}
                  />
                </CustomTable>
              </>)}
          </Box>

        </GridItem>
      </Grid>

      <AlertCard
        isOpen={!!deleteAward}
        onClose={() => setDeleteAward(null)}
        onConfirm={confirmDelete}
        title="Delete Award"
        description={`Are you sure you want to delete this Award&Certificate ?`}
        confirmLabel="Delete"
        cancelLabel="Cancel"
        colorScheme="red"
        isLoading={loading}
      />


      <CreateNewAward
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setEditAward(null);
        }}
        refresh={fetchAwards}
        editData={editAward}
        onUpdate={handleUpdate}

      />
    </MyDiv>
  );
};

export default AdminCertificate;
